const ReceivedInquiryColumns = [
  {
    binding: 'BuyerName',
    name: 'BuyerName',
    header: '采购商',
    visible: true,
    dataType: 1,
    isReadOnly: false,
    isFieldSearch: true,
    isSystem: false
  },
  {
    binding: 'Model',
    name: 'Model',
    header: '需求型号/品牌',
    visible: true,
    dataType: 1,
    isReadOnly: false,
    isFieldSearch: false,
    isSystem: false
  },
  {
    binding: 'RequiredQty',
    name: 'RequiredQty',
    header: '需求量',
    visible: true,
    dataType: 1,
    isReadOnly: false,
    isFieldSearch: false,
    isSystem: false,
    width: 160
  },
  {
    binding: 'Border',
    name: 'Border',
    header: '',
    visible: true,
    dataType: 1,
    isReadOnly: false,
    isFieldSearch: false,
    isSystem: false,
    width: 100,
    className: 'border-cell'
  },
  {
    binding: 'MyModel',
    name: 'MyModel',
    header: '我的型号/品牌',
    visible: true,
    dataType: 1,
    isReadOnly: false,
    isFieldSearch: false,
    isSystem: false
  },
  {
    binding: 'Qty',
    name: 'Qty',
    header: '我的库存',
    visible: true,
    dataType: 1,
    isReadOnly: false,
    isFieldSearch: false,
    isSystem: false,
    width: 120
  },
  {
    binding: 'Offer',
    name: 'Offer',
    header: '报价',
    visible: true,
    dataType: 1,
    isReadOnly: false,
    isFieldSearch: false,
    isSystem: false,
    width: 140
  },
  {
    binding: 'Operation',
    name: 'Operation',
    header: '操作',
    visible: true,
    dataType: 1,
    isReadOnly: false,
    isFieldSearch: false,
    isSystem: false,
    width: 100
  }
];

export { ReceivedInquiryColumns };
